import React, { PropTypes, Component } from 'react';
import Fuse from 'fuse.js';
import { PromiseState } from 'react-refetch';
import { Hero, SearchBar, GlossaryDetail, PromiseStateContainer } from '../../components';
import { setGlossaryList, objectIsEmpty } from '../../utils';
import { glossaryConnect } from '../../connect';

class Glossary extends Component {
  state = {
    search: '',
    searchTerms: []
  };

  updateSearch = event => {
    this.setState({ search: event.target.value }, this.filterGlossaryWithSearch);
  };

  filterGlossaryWithSearch() {
    const options = {
      shouldSort: true,
      threshold: 0.3,
      location: 0,
      distance: 1000,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: ['term']
    };
    const fuse = new Fuse(this.props.glossary, options);
    if (this.state.search.length) {
      const fuseSearch = fuse.search(this.state.search);
      this.setState({ searchTerms: fuseSearch });
    } else {
      this.setState({ searchTerms: this.props.glossary });
    }
  }

  render() {
    const { glossary, glossaryFetch, children } = this.props;
    const { search, searchTerms } = this.state;
    const items = setGlossaryList(glossary);
    return (
      <div>
        <Hero />
        <SearchBar searchValue={search} onChangeSearch={this.updateSearch} />
        <section className="glossary">
          <div className="glossary-container">
            <div className="container">
              <div className="row">
                {!objectIsEmpty(items)
                  ? <GlossaryDetail search={search} searchTerms={searchTerms} terms={items} />
                  : <PromiseStateContainer
                      ps={PromiseState.race([glossaryFetch])}
                      onFulFillment={terms => (
                        <GlossaryDetail
                          search={search}
                          searchTerms={searchTerms}
                          terms={setGlossaryList(terms)}
                        />
                      )}
                    />}
              </div>
              {children}
            </div>
          </div>
        </section>
      </div>
    );
  }
}

Glossary.propTypes = {
  glossary: PropTypes.arrayOf(
    PropTypes.shape({
      term: PropTypes.string.isRequired,
      letter: PropTypes.string.isRequired,
      definition: PropTypes.string.isRequired,
      subitems: PropTypes.object
    })
  ).isRequired,
  glossaryFetch: PropTypes.instanceOf(PromiseState).isRequired,
  children: PropTypes.element
};

export default glossaryConnect(Glossary);



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/containers/Glossary/Glossary.js